import { ChainType } from "@0xsquid/squid-types";
import { UseMutationResult } from "@tanstack/react-query";
import React, { createContext, useContext } from "react";
import { useEvm } from "../../hooks/evm/useEvm";
import { EvmConnector } from "../types/evm";
import { ConnectWalletResult, EvmWallet } from "../types/wallet";

export interface IEvmContextData {
  connectEvm: UseMutationResult<
    ConnectWalletResult<ChainType.EVM>,
    unknown,
    {
      wallet: EvmWallet;
    },
    unknown
  >;
  disconnectEvm: () => Promise<void>;
  autoConnectEvm: () => Promise<void>;
  signer: EvmConnector | undefined;
  wallets: EvmWallet[];
}

export const EvmContext = createContext<IEvmContextData | undefined>(undefined);

export const EvmProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const evmContext = useEvm();

  return (
    <EvmContext.Provider value={evmContext}>{children}</EvmContext.Provider>
  );
};

export const useEvmContext = (): IEvmContextData => {
  const context = useContext(EvmContext);
  if (!context) {
    throw new Error("useEvmContext must be used within a EvmProvider");
  }
  return context;
};
